import request from '@/utils/request';
export function fetchList(data) {
  return request({
    url: '/userservice/api/dict/list',
    method: 'post',
    data: data
  });
}
export function fetchListByType(dicType) {
  var data = {
    dicType: dicType
  };
  return request({
    url: '/userservice/api/dict/list',
    method: 'post',
    data: data
  });
}
export function fetchLinkageTree() {
  return request({
    url: '/dict/getDicLinkageList',
    method: 'post'
  });
}